import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useState, useRef, useMemo } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';

import { SecondaryButtonRegular } from './Button';
import dayjs from 'dayjs';
import { SMBold } from '@/typography/Typography';
import { DATE_FORMAT } from '@/lib/constants';
import { StaticDatePicker } from '@mui/x-date-pickers';

export interface MonthPickerProps {
    label: string;
    value: Date;
    onChange: (value: any | any[]) => void;
    onClose?: () => void;
}

export const MonthPicker = ({ value, onChange, onClose }: MonthPickerProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const customInputRef = useRef<any>(undefined);

    const label = useMemo(() => {
        if (value) {
            return dayjs(value).format(DATE_FORMAT.MONTH_YEAR);
        }
    }, [value]);

    const onCloseHandle = () => {
        setIsOpen(false);
        onClose?.();
    };

    return (
        <div>
            <SecondaryButtonRegular onClick={() => setIsOpen((prev) => !prev)}>
                <CalendarTodayOutlinedIcon />
                <Box ml={1}>
                    <SMBold>{label}</SMBold>
                </Box>
            </SecondaryButtonRegular>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDatePicker
                    sx={{
                        display: isOpen ? 'block' : 'none',
                        position: 'absolute',
                        zIndex: 1000,
                        '& .MuiPickersLayout-actionBar': {
                            display: 'none'
                        },
                        '& .MuiDialogActions-root': {
                            display: 'none'
                        },
                        border: '1px solid #E0E0E0',
                        borderRadius: '8px'
                    }}
                    openTo="month"
                    views={['year', 'month']}
                    slotProps={{
                        toolbar: { hidden: true },
                        layout: {
                            sx: {
                                '& .MuiDateCalendar-root': {
                                    height: 'auto'
                                }
                            }
                        }
                    }}
                    onMonthChange={(newValue) => {
                        onChange(newValue);
                        onCloseHandle();
                    }}
                    value={dayjs(value)}
                />
            </LocalizationProvider>
        </div>
    );
};
